@if (items().length > 0) {
  <!-- TODO: we do have ux issue : scrolling tabs is poor design  -->
  <nav
    data-testid="nav-primary"
    class="nav"
    evcHorizontalWheelScroll
    evcIsScrollable
    scrollPosition="bottom"
    [attr.data-host]="host()">
    @for (item of items(); track item.key) {
      <evc-button
        class="item nav__item"
        [attr.data-testid]="item.key"
        [frame]="buttonFrame()"
        [type]="getItemType(item)"
        [active]="!!item.selected"
        [text]="(item.text! | optionalAsync) ?? ''"
        [href]="item.href"
        [routerLink]="item.routerLink"
        (click)="onItemClick(item)"
        style="--button-padding: 0.75rem" />
    }
  </nav>
}
